module.exports = __webpack_public_path__ + "img/player.e2037e24.png";